"use strict";

require("core-js/modules/es.promise.finally");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _text = _interopRequireDefault(require("./text"));

require("./remark-ninja.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var rnUrlPrefix = 'https://api.rmninja.com';

var checkHttpStatus = function checkHttpStatus(resp) {
  if (resp.status >= 400) {
    throw new Error(resp.data.message);
  } else {
    return resp.data;
  }
};

var loadComments = function loadComments(_ref) {
  var siteId = _ref.siteId,
      threadSlug = _ref.threadSlug,
      start = _ref.start,
      limit = _ref.limit;
  start = start === undefined ? 0 : start;
  limit = limit === undefined ? 10 : limit;
  threadSlug = threadSlug || location.pathname;
  return _axios["default"].get(rnUrlPrefix + "/api/1/sites/" + encodeURIComponent(siteId) + "/threads/" + encodeURIComponent(threadSlug) + "/comments", {
    params: {
      start: start,
      limit: limit
    }
  }).then(checkHttpStatus);
};

var postComment = function postComment(_ref2) {
  var siteId = _ref2.siteId,
      threadSlug = _ref2.threadSlug,
      authorName = _ref2.authorName,
      authorEmail = _ref2.authorEmail,
      body = _ref2.body,
      replyToComment = _ref2.replyToComment;
  threadSlug = threadSlug || location.pathname;
  return _axios["default"].post(rnUrlPrefix + "/api/1/comments", {
    siteId: siteId,
    threadSlug: threadSlug,
    authorName: authorName,
    authorEmail: authorEmail,
    body: body,
    replyToComment: replyToComment
  }).then(checkHttpStatus);
};

var lsGet = function lsGet(key) {
  return typeof localStorage !== 'undefined' && localStorage.getItem(key);
};

var lsSet = function lsSet(key, val) {
  return typeof localStorage !== 'undefined' && localStorage.setItem(key, val);
};

var lsAuthorNameKey = 'rnCommentAuthorName';
var lsAuthorEmailKey = 'rnCommentAuthorEmail';

var scrollTo = function scrollTo(hash) {
  location.hash = "#" + hash;
};

var CommentForm = function CommentForm(_ref3) {
  var siteId = _ref3.siteId,
      threadSlug = _ref3.threadSlug,
      onNewComment = _ref3.onNewComment,
      replyingTo = _ref3.replyingTo;

  var _useState = (0, _react.useState)(lsGet(lsAuthorNameKey) || ''),
      authorName = _useState[0],
      setAuthorName = _useState[1];

  var _useState2 = (0, _react.useState)(lsGet(lsAuthorEmailKey) || ''),
      authorEmail = _useState2[0],
      setAuthorEmail = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      body = _useState3[0],
      setBody = _useState3[1];

  var _useState4 = (0, _react.useState)(undefined),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = (0, _react.useState)(undefined),
      message = _useState5[0],
      setMessage = _useState5[1];

  (0, _react.useEffect)(function () {
    if (replyingTo) {
      var replyingToUser = replyingTo.authorName || 'Guest';
      setBody("@" + replyingToUser + " ");
    } else {
      setBody('');
    }
  }, [replyingTo]);

  var submit = function submit(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = e.target;
    btn.disabled = true;
    lsSet(lsAuthorNameKey, authorName);
    lsSet(lsAuthorEmailKey, authorEmail);
    setError(undefined);
    setMessage(undefined);
    postComment({
      siteId: siteId,
      threadSlug: threadSlug,
      authorName: authorName,
      authorEmail: authorEmail,
      body: body,
      replyToComment: replyingTo ? replyingTo.id : undefined
    }).then(function () {
      setMessage((0, _text["default"])('submitted'));
      setBody('');
      onNewComment();
    })["catch"](function (e) {
      setError(e.message);
    })["finally"](function () {
      btn.disabled = false;
    });
  };

  return /*#__PURE__*/_react["default"].createElement("form", {
    className: "rn-comment-form",
    id: "rn-comment-form"
  }, error !== undefined && /*#__PURE__*/_react["default"].createElement("div", {
    className: "rn-error"
  }, error), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rn-author-box"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "rn-author-name-box"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "rn-author-name"
  }, (0, _text["default"])('name')), /*#__PURE__*/_react["default"].createElement("input", {
    id: "rn-author-name",
    value: authorName,
    onChange: function onChange(e) {
      return setAuthorName(e.target.value);
    },
    placeholder: (0, _text["default"])('name_placeholder')
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rn-author-email-box"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "rn-author-email"
  }, (0, _text["default"])('email')), /*#__PURE__*/_react["default"].createElement("input", {
    id: "rn-author-email",
    type: "email",
    placeholder: (0, _text["default"])('email_placeholder'),
    value: authorEmail,
    onChange: function onChange(e) {
      return setAuthorEmail(e.target.value);
    }
  }))), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "rn-body"
  }, (0, _text["default"])('comment')), /*#__PURE__*/_react["default"].createElement("textarea", {
    id: "rn-body",
    rows: "5",
    value: body,
    onChange: function onChange(e) {
      return setBody(e.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement("input", {
    onClick: submit,
    type: "submit",
    value: (0, _text["default"])('submit')
  }), message !== undefined && /*#__PURE__*/_react["default"].createElement("span", {
    className: "rn-success"
  }, message), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rn-promo-link"
  }, (0, _text["default"])('powered_by'), " ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://remark.ninja"
  }, "Remark Ninja"), "."));
};

var Comment = function Comment(_ref4) {
  var authorName = _ref4.authorName,
      gravatarHash = _ref4.gravatarHash,
      body = _ref4.body,
      createdAt = _ref4.createdAt,
      replyFn = _ref4.replyFn;
  var date = new Date(createdAt);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "rn-comment-item"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "rn-gravatar"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "Avatar for " + authorName,
    src: "https://www.gravatar.com/avatar/" + gravatarHash + "?s=40"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rn-main-section"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "rn-author-name"
  }, authorName || (0, _text["default"])('guest')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rn-comment-actions"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "rn-date"
  }, date.toLocaleDateString()), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: replyFn
  }, "Reply")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rn-comment-body",
    dangerouslySetInnerHTML: {
      __html: body
    }
  })));
};

var Comments = function Comments(_ref5) {
  var siteId = _ref5.siteId,
      threadSlug = _ref5.threadSlug,
      pageSize = _ref5.pageSize;

  var _useState6 = (0, _react.useState)(undefined),
      comments = _useState6[0],
      setComments = _useState6[1];

  var _useState7 = (0, _react.useState)(undefined),
      error = _useState7[0],
      setError = _useState7[1];

  var _useState8 = (0, _react.useState)(0),
      start = _useState8[0],
      setStart = _useState8[1];

  var _useState9 = (0, _react.useState)(undefined),
      replyingTo = _useState9[0],
      setReplyingTo = _useState9[1];

  var limit = pageSize === undefined ? 20 : pageSize;

  var load = function load() {
    loadComments({
      siteId: siteId,
      threadSlug: threadSlug,
      start: start,
      limit: limit
    }).then(function (cs) {
      setComments(cs);
      setError(undefined);
      setReplyingTo(undefined);
    })["catch"](function (e) {
      setError(e.message);
    });
  };

  var prevPage = function prevPage() {
    setStart(Math.max(start - limit, 0));
  };

  var nextPage = function nextPage() {
    setStart(start + limit);
  };

  (0, _react.useEffect)(load, [siteId, threadSlug, pageSize, start, limit]);

  if (comments === undefined && error === undefined) {
    return /*#__PURE__*/_react["default"].createElement("div", null, (0, _text["default"])('loading_comments'));
  } else if (comments == undefined && error !== undefined) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "rn-error"
    }, "Failed to load comments: ", error);
  } else {
    return /*#__PURE__*/_react["default"].createElement("div", null, !!replyingTo && /*#__PURE__*/_react["default"].createElement("div", null, "Replying to", ' ', /*#__PURE__*/_react["default"].createElement("a", {
      href: "#rn-comment-" + replyingTo.id
    }, replyingTo.authorName || 'Guest'), ' ', /*#__PURE__*/_react["default"].createElement("button", {
      className: "cancelReply",
      onClick: function onClick() {
        return setReplyingTo(undefined);
      }
    }, "X")), /*#__PURE__*/_react["default"].createElement(CommentForm, {
      siteId: siteId,
      threadSlug: threadSlug,
      onNewComment: load,
      replyingTo: replyingTo
    }), !!error && /*#__PURE__*/_react["default"].createElement("div", {
      className: "rn-error"
    }, error), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "rn-comment-list"
    }, comments.map(function (c) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: c.id,
        id: "rn-comment-" + c.id
      }, /*#__PURE__*/_react["default"].createElement(Comment, {
        authorName: c.authorName,
        gravatarHash: c.gravatarHash,
        body: c.bodyHTML,
        createdAt: c.createdAt,
        replyFn: function replyFn() {
          setReplyingTo(c);
          scrollTo('rn-comment-form');
        }
      }));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rn-pagination"
    }, start > 0 && /*#__PURE__*/_react["default"].createElement("a", {
      onClick: prevPage
    }, (0, _text["default"])('prev_page')), comments.length === limit && /*#__PURE__*/_react["default"].createElement("a", {
      onClick: nextPage
    }, (0, _text["default"])('next_page'))));
  }
};

var _default = Comments;
exports["default"] = _default;
module.exports = exports.default;